import Api from "../index";
import { endPoints, requestType } from "../../constants/variables";

// get products
export const getAdminDashboardData = (params) => {
  return Api(`${endPoints.adminDashboard}`, null, requestType.GET);
};
